import React from 'react';

const CtaUrl = ({ width = 22, height = 20, color = 'white' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 22 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.5 14.667H5.83333C4.82081 14.667 4 13.8462 4 12.8337V7.16699C4 6.15447 4.82081 5.33366 5.83333 5.33366H10.5C11.5125 5.33366 12.3333 6.15447 12.3333 7.16699V8.50033M7.83333 10.0003H14.6667M14.6667 10.0003L12.3333 11.5003M14.6667 10.0003L12.3333 8.50033M18 10.0003C18 10.9208 17.2538 11.667 16.3333 11.667C15.4129 11.667 14.6667 10.9208 14.6667 10.0003C14.6667 9.07985 15.4129 8.33366 16.3333 8.33366C17.2538 8.33366 18 9.07985 18 10.0003Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default CtaUrl;
